export const SET_SESSION    = 'SET_SESSION'
export const CLEAR_SESSION  = 'CLEAR_SESSION'